import { Timestamp } from 'firebase/firestore';

export enum TaskStatus {
  PENDING = 'pending',
  COMPLETED = 'completed'
}

export interface Task {
  id: string;
  title: string;
  description?: string;
  status: TaskStatus;
  dueDate?: Timestamp;
  completedAt?: Timestamp;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  position: number;
  parentId?: string;
  attachments?: string[];
  subtasks?: SubTask[];
}

export interface SubTask {
  id: string;
  title: string;
  completed: boolean;
  position: number;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export interface CreateTaskData {
  title: string;
  description?: string;
  dueDate?: Date;
  parentId?: string;
}

export interface UpdateTaskData {
  title?: string;
  description?: string;
  status?: TaskStatus;
  dueDate?: Date;
  position?: number;
  parentId?: string;
  attachments?: string[];
  subtasks?: SubTask[];
}

export interface GroupedTasks {
  pending: Task[];
  completed: Task[];
}

export interface TasksResponse {
  tasks: GroupedTasks;
}
